import { gradientStore, getNavGradient } from './gradient-store.js';

export function initNavGradient() {
  const nav = document.querySelector('nav');

  if (!nav) {
    return;
  }

  // Subscribe to Redux store for nav gradient updates
  let lastGradient = null;

  function updateNavGradient() {
    const state = gradientStore.getState();

    // Skip update if animation is disabled
    if (!state.animationEnabled) {
      return;
    }

    const gradient = getNavGradient(state);

    // Skip update if gradient hasn't changed (performance optimization)
    if (gradient === lastGradient) {
      return;
    }

    lastGradient = gradient;

    // Apply gradient via CSS variable
    nav.style.setProperty('--nav-gradient', gradient);
  }

  // Initial update
  updateNavGradient();

  // Subscribe to Redux store
  gradientStore.subscribe(updateNavGradient);

  return {
    updateNavGradient,
  };
}
